import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { StyledButton } from './style';
import Icon from '../Icon';

let debounceTimeout;

const CTA = ({
  type = 'primary',
  btnText,
  disabled,
  fullsize,
  classes,
  onClick,
  icon,
  iconSize = 24,
  iconPosition = 'end',
  bottomRight,
  compact,
  hiddenLabel,
  id,
  isSpinning,
}) => {
  // prevent double clicks
  const [ctaClicked, setCtaClicked] = useState(false);
  const debouncedClick = (e) => {
    if (debounceTimeout) return;

    if (typeof onClick === 'function') {
      onClick(e);
    }
    setCtaClicked(true);
    debounceTimeout = setTimeout(() => {
      debounceTimeout = null;
    }, 250);
  };

  useEffect(() => {
    if (!isSpinning && ctaClicked) setCtaClicked(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSpinning]);

  return (
    <StyledButton
      className={`${type} ${classes}`}
      disabled={disabled || (isSpinning && ctaClicked)}
      fullsize={fullsize}
      onClick={debouncedClick}
      bottomRight={bottomRight}
      compact={compact}
      id={id}
    >
      <span className={hiddenLabel ? 'visually-hidden' : ''}>{btnText}</span>
      {icon && <Icon type={`${icon}`} stroke="currentcolor" size={iconSize} />}
    </StyledButton>
  );
};

CTA.propTypes = {
  btnText: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  disabled: PropTypes.bool,
  fullsize: PropTypes.bool,
  classes: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  iconPosition: PropTypes.oneOf(['start', 'end']),
  bottomRight: PropTypes.bool,
  compact: PropTypes.bool,
  hiddenLabel: PropTypes.bool,
  id: PropTypes.string,
  isSpinning: PropTypes.bool,
};

export default connect((state) => {
  const { isSpinning } = state.app.loader;
  return { isSpinning };
})(CTA);
